// ============ بيانات المشاريع ============
// المشاريع بقت بتتبني تلقائيًا من آخر مشاريع كل مطوّر في Developersdata (مصدر واحد):
// يعني لو عدّلت سعر أو موعد تسليم هناك، بيتعدل في الهوم وصفحة المشاريع وصفحة المطوّر مع بعض.
//
// الهوم بيعرض المشاريع اللي الـ id بتاعها في FEATURED (بنفس الترتيب).
// الـ id بيتعمل من الاسم الإنجليزي: "Golf Fields" => "golf-fields" والرابط /project/golf-fields

import { DEV_DETAILS, AREAS, TYPES, L, M, pick } from "./Developersdata";

export { AREAS, TYPES, L, M, pick };

export const slugify = (s) =>
  String(s)
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const FEATURED = [
  "valia",
  "damac-islands-2",
  "mercedes-benz-places-binghatti-city",
  "the-meriva-collection",
  "greenz-by-danube",
  "bay-estate",
];

export const PROJECTS = DEV_DETAILS.flatMap((d) =>
  d.recent.map((pr) => {
    const id = slugify(pr.name.en);
    return { id, dev: d.slug, ...pr, featured: FEATURED.includes(id) };
  })
);

// ===== helpers =====
export const getProject = (id) => PROJECTS.find((x) => x.id === id);
export const projectsByDev = (slug) => PROJECTS.filter((x) => x.dev === slug);
export const featuredProjects = () =>
  FEATURED.map((id) => PROJECTS.find((x) => x.id === id)).filter(Boolean);
